<template>
  <div class="about-us">
    <div class="about-us-banner">
      <img :src="currentPageType === 8 ? require('@/assets/images/about_us/jiaruwomen.png') : loadUrl.banner_bg" />
      <div>{{ currentPageType === 8 ? '火热招聘' : '关于我们' }}</div>
    </div>
    <div class="about-us-content" :class="currentPageType === 8 ? 'job-content' : ''">
      <!-- 公司介绍内容 -->
      <template v-if="currentPageType === 7">
        <div class="introduce">
          <div>公司介绍</div>
          <div>
            <div>混空是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，为文娱、商业、工业、教育行业提供综合解决方案。</div>
            <div>混空自研多项核心底层技术，专注于视觉+AI算法融合，实现厘米级空间定位。核心产品混空 Studio（智能体）是一款AI+AR元宇宙内容创作与分发平台，帮助用户一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。</div>
            <div>公司获得国家级高新技术企业认定、国家双软企业认定和国家科技型中小企业认定，已申请70多项知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙头部公司。</div>
          </div>
        </div>
        <div class="company-profile">
          <img :src="loadUrl.company_profile" />
        </div>
      </template>
      
      <!-- 加入我们内容 -->
      <template v-else-if="currentPageType === 8">
        <!-- 面包屑导航 -->

        <div style="    width: 100%;
    max-width: 1200rem;
    margin: 0 auto; text-align: start;" >
         <div class="breadcrumb" v-if="currentJobView === 'detail'">
          <span @click="backToJobList" class="breadcrumb-link">加入我们</span>
          <span class="breadcrumb-separator"> > </span>
          <span class="breadcrumb-current">{{ jobList[selectedJobIndex].title }}</span>
        </div>
        </div>
       
        
        <!-- 招聘卡片列表 -->
        <div v-if="currentJobView === 'list'" class="job-cards-container">
          <div class="job-card" v-for="(job, index) in jobList" :key="index" @click="showJobDetail(index)">
            <div class="job-title">{{ job.title }}</div>
            <div class="job-subtitle">【岗位职责】</div>
            <div class="job-responsibilities">
              <div v-for="(responsibility, idx) in job.responsibilities" :key="idx">
                {{ idx + 1 }}. {{ responsibility }}
              </div>
            </div>
          </div>
        </div>
        
        <!-- 职位详情页面 -->
        <div v-else-if="currentJobView === 'detail'" class="job-detail-container">
          <div class="job-detail-content">
           
            <div class="job-detail-section">
              <div class="job-detail-subtitle">【岗位职责】</div>
              <div class="job-detail-responsibilities">
                <div v-for="(responsibility, idx) in jobList[selectedJobIndex].detailResponsibilities" :key="idx">
                  {{ idx + 1 }}. {{ responsibility }}
                </div>
              </div>
            </div>
            
            <div class="job-detail-section">
              <div class="job-detail-subtitle">【投递方式】</div>
              <div class="contact-methods">
                <div class="contact-method">
                  <div class="contact-label">邮箱投递：</div>
                  <div class="contact-value">{{ jobList[selectedJobIndex].contactMethod.email }}</div>
                </div>
                <div class="contact-method">
                  <div class="contact-label">微信投递：</div>
                  <div class="contact-qr">
                    <!-- 这里应该显示二维码图片 -->
                    <img src="@/assets/images/about_us/erweima22.png" style="width: 160rem; height:   160rem" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      
      <!-- <div class="honor">
        <div class="title">荣誉及资质</div>
      </div> -->
      <div class="ryzz honor" v-if="currentPageType === 7">
        <div class="title">荣誉资质</div>
        <div class="ryzz-list">
          <div class="ryzz-viewport">
            <el-carousel :interval="3000" type="card" height="400rem" arrow="hover" :indicator-position="'none'">
              <el-carousel-item v-for="(item, index) in honors" :key="index">
                <div class="honors-card">
                  <img :src="item.url" />
                  <div class="honors-text">
                    <div v-for="(e, i) in item.illustrate" :key="i">{{ e }}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="xwzx" v-if="currentPageType === 7">
        <div class="title-font-style title">公司动态</div>
        <div class="xwzx-box">
          <div @click="toOtherPath(newsList[activeNewsIndex].relatedHtmlId, newsList[activeNewsIndex].title)">
            <img v-if="newsList[activeNewsIndex]" :src="newsList[activeNewsIndex].ossPath || ''" />
          </div>
          <div>
            <div class="news-content">
              <div v-for="(e, i) in newsList" :key="i" @click="toOtherPath(e.relatedHtmlId, e.title)"
                :class="activeNewsIndex == i ? 'active' : ''">
                <div>{{ e.title }}</div>
                <div>{{ e.times }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bg-video">
      <video :src="loadUrl.particle_moment_mp4" autoplay loop muted playsinline webkit-playsinline></video>
      <div class="contact-us">
        <div class="title">成功提交信息，可享专业客服一对一支持</div>
        <div class="form-wrap">
          <el-input class="form-input" :class="checkEmpty.companyName ? 'error-cn' : ''"
            v-model="contactInfo.companyName" placeholder="公司名称" />
          <el-input class="form-input" :class="checkEmpty.name ? 'error-n' : ''" v-model="contactInfo.name"
            placeholder="姓名" />
          <el-input class="form-input" :class="(showError || checkEmpty.phone) ? 'error-text' : ''"
            v-model="contactInfo.phone" placeholder="电话" />
          <el-select placeholder="所属行业" :class="checkEmpty.industry ? 'error-i' : ''" v-model="contactInfo.industry"
            class="select-default" popper-class="select-option">
            <el-option v-for="(item, index) in industryList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </div>
        <div class="submit-btn" @click="submitEvent">提交信息</div>
      </div>
      <div class="contact-service" v-if="showCustomerState == 2">
        <div class="closed" @click="showCustomerState = 0"></div>
        <div class="title">联系我们的团队</div>
        <div class="title-tips">你可以通过以下几种方式联系我们，我们将为您提供专业的解答</div>
        <div class="service-list">
          <div style="padding: 29rem 0;">
            <img src="@/assets/images/home/customer.jpg" />
            <span>扫码添加客服微信</span>
          </div>
          <div>
            <div class="fontBold">购买咨询</div>
            <div class="fontBold">400-900-6269</div>
            <div class="fontNormal">工作日：9:30-18:30（北京时间）</div>
          </div>
          <div>
            <div class="fontBold">联系邮箱</div>
            <div class="fontBold">yang.he@njyjxr.com</div>
            <div class="fontNormal">48小时之内回复</div>
          </div>
        </div>
      </div>
      <contact-us :changeState="changeState" :state-value="showCustomerState"></contact-us>
    </div> -->
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import store from '@/store';
import { useRoute } from 'vue-router';
import { ElCarousel, ElCarouselItem } from 'element-plus'
// import ContactUs from '@/components/ContactUs.vue';
import { asynchronousRetrieval } from '@/utils'
const route = useRoute();
const loadUrl: any = ref({})
const currentPageType = ref(7) // 7: 公司介绍, 8: 加入我们
const currentJobView = ref('list') // 'list': 卡片列表, 'detail': 职位详情
const selectedJobIndex = ref(0) // 当前选中的职位索引

// 招聘岗位数据
const jobList = ref([
  {
    title: '算法工程师（图像识别方向）',
    responsibilities: [
      '负责图像识别算法研发部署，优化模型适配端侧，协作封装SDK，跟踪前沿技术迭代。',
      '主导图像识别算法开发，轻量化模型保帧率，压缩优化适配设备，协作攻坚提性能。'
    ],
    detailResponsibilities: [
      '主导微信小程序插件中图像识别算法的研发与部署，覆盖平面识别、人脸识别、2D标记识别、图片分类、手势识别、身体姿态估计等核心功能，替代微信原生API并提升性能与精度。',
      '设计轻量化深度学习模型（如MobileNet、YOLO变体），适配小程序端运行环境（WebAssembly/微信原生框架），实现高帧率（≥30fps）实时推理。',
      '构建多任务学习框架，优化多模态识别协同（如平面检测与人脸识别联合推理），降低计算冗余与内存占用。',
      '开发数据增强与合成技术，针对小程序场景优化数据集（如复杂光照、遮挡、低分辨率图像），提升算法鲁棒性。',
      '与前端团队协作完成算法集成，封装高效SDK接口，解决模型部署中的性能瓶颈（如JS与Native代码通信延迟）。',
      '探索模型量化（INT8/FP16）、剪枝、蒸馏等压缩技术，将模型体积控制在5MB以内，适配低端机型CPU/GPU/NPU异构计算。',
      '跟踪前沿技术（如Vision Transformer、神经架构搜索），推动算法在识别准确率与效率上的持续迭代。'
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '算法工程师（SLAM方向）',
    responsibilities: [
      '负责AR增强现实相关的重建、定位、跟踪等核心算法开发和优化；',
      '研发AR重建定位算法，优化多模态数据融合，解决跨平台性能问题，协作打造AR/VSLAM产品方案。'
    ],
    detailResponsibilities: [
      '负责AR增强现实相关的重建、定位、跟踪等核心算法开发和优化。',
      '负责AR/VSLAM系统的核心算法设计、实现与优化，包括特征提取、特征匹配、位姿估计、闭环检测、地图构建等模块。',
      '提升算法在复杂场景下的鲁棒性（如低纹理、动态物体、光照变化等）和实时性。',
      '结合IMU、RGB-D相机、LiDAR、ToF等多模态传感器数据，优化VSLAM系统的精度和稳定性。',
      '将算法移植到移动端（iOS/Android）、AR眼镜、机器人或嵌入式平台，解决性能优化（如内存、算力、功耗）问题。',
       '跟踪学术界与工业界最新进展（如神经辐射场NeRF、语义SLAM、端到端SLAM等），推动技术落地。',
       '与3D渲染、计算机视觉、硬件团队合作，打造完整的AR/VSLAM产品解决方案。'
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '前端开发工程师',
    responsibilities: [
      '负责AR小程序插件开发，基于Vue/WebGL构建3D渲染组件，优化性能与数据通信，协作算法移植并输出技术文档。',
      '开发AR小程序框架与3D渲染模块，解决性能瓶颈，协作算法移植，编写规范助力客户端集成。'
    ],
    detailResponsibilities: [
      '负责AR小程序插件的基础框架设计与开发，基于Vue技术栈实现可视化组件的模块化设计与功能扩展。',
      '开发基于WebGL/Three.js的高性能3D渲染组件库，构建浏览器端AR场景交互与虚实融合解决方案。',
      '开发基于WebGL/WebAssembly的高性能3D渲染模块，支持实时SLAM建图、AR场景交互及虚实融合效果。',
      '优化B/S架构下的三维数据通信机制，设计前后端分离的数据加载与渲染策略。',
      '解决小程序平台的性能瓶颈（如内存管理、多线程渲染、实时数据同步），保障SLAM算法的流畅运行。',
      '与算法团队协作，完成SLAM算法的前端移植、数据通信及可视化调试。',
      '编写技术文档，输出插件开发规范及接入指南，支持客户端的快速集成与问题排查。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '产品经理',
    responsibilities: [
      '负责产品全生命周期管理，挖掘需求、输出方案。',
      '协调团队推进开发，跟踪数据与反馈，优化产品并提交分析报告。'
    ],
    detailResponsibilities: [
      '负责产品全生命周期管理，包括需求挖掘、规划设计与迭代优化，确保产品满足用户与业务目标。',
      '负责与客户、业务方沟通需求，输出产品 PRD、原型图，制定产品 roadmap 及版本迭代时间表。',
      '负责协调研发、设计、测试等团队，跟进产品开发进度，及时发现并解决项目推进中的问题。',
      '监控产品上线后的运营数据与用户反馈，分析用户行为，提出产品优化方案并推动落地。',
      '配合团队建立规范的产品管理流程，包括需求评审、版本规划、上线验收等，监督流程执行。',
      '对产品市场表现、用户满意度进行跟踪评估，开展竞品分析，输出产品优化与迭代建议。',
      '定期提交产品分析报告，反馈产品进度、数据表现及待优化问题，形成书面总结与改进计划。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '销售经理',
    responsibilities: [
      '针对元宇宙行业，寻找目标B端客户。',
      '掌握公司产品的优势及操作，为客户做产品演示，借助公司产品为客户提供解决方案。'
    ],
    detailResponsibilities: [
      '针对元宇宙行业，寻找目标客户（B端）。',
      '约访客户，面谈沟通，分析客户需求及痛点，为客户提供专业的解决方案。',
      '熟练掌握公司SaaS产品的优势及操作，能为客户做产品演示，借助公司产品为客户提供SaaS系统的解决方案，实现签约。',
      '配合产品售前售后支持人员完成客户系统搭建。',
      '大专及以上学历，有软件销售工作优先。',
      '对销售工作主动热情，有目标感。',
      '有良好的客户意识，思维敏捷，具有较强的说服力及团队合作精神。',
      '追求更高工资、有长远发展的动力。',
      '能扛压，愿意与公司共同成长。',
      '能接受出差。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  }
])

let timer3: any = null;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力', '50佳创业企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）', '专业赛 一等奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const activeNewsIndex = ref(0)
const contactInfo: any = reactive({
  companyName: '',
  name: '',
  phone: '',
  industry: null
})
const showCustomerState = ref(0)
const industryList = [
  {
    name: '文娱',
    value: 1,
  },
  {
    name: '工业',
    value: 2,
  },
  {
    name: '教育',
    value: 3,
  },
  {
    name: '其他',
    value: 4,
  }
]
const showError = ref(false)
const checkEmpty: any = ref({})

const submitEvent = () => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  Object.keys(contactInfo).forEach((k) => {
    checkEmpty.value[k] = !contactInfo[k]
  })
  if (!reg.test(contactInfo.phone.replace(/\s+/g, "")) || !contactInfo.phone) {
    showError.value = true;
    return
  } else if (!contactInfo.companyName || !contactInfo.name || !contactInfo.industry) {
    return
  }
  addConsult({ ...contactInfo }).then((res: any) => {
    showCustomerState.value = 2;
    contactInfo.companyName = ''
    contactInfo.name = ''
    contactInfo.phone = ''
    contactInfo.industry = null
    showError.value = false;
    checkEmpty.value = {}
  })
}

const changeState = (val: number) => {
  showCustomerState.value = val;
}


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `新闻中心 / 新闻详情 / ${title}`
}

// 点击招聘卡片，显示详情页面
const showJobDetail = (index: number) => {
  selectedJobIndex.value = index;
  currentJobView.value = 'detail';
}

// 返回卡片列表页面
const backToJobList = () => {
  currentJobView.value = 'list';
}

onMounted(async () => {
  // 处理路由参数
  const type = route.query.type;
  if (type && +type === 8) {
    currentPageType.value = 8; // 加入我们
  } else {
    currentPageType.value = 7; // 公司介绍
  }

  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer3)
})

// 监听路由变化
watch(() => route.query.type, (newType) => {
  if (newType && +newType === 8) {
    currentPageType.value = 8; // 加入我们
    // 重置职位详情页面状态
    currentJobView.value = 'list';
  } else {
    currentPageType.value = 7; // 公司介绍
  }
});
</script>
<style scoped lang="less">
.about-us-banner {
  position: relative;
  height: 24.875vw;
  line-height: 26.302vw;
  text-align: center;
  font-weight: 600;
  font-size: 3.33vw;
  color: #FFFFFF;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }

  &>div {
    position: relative;
    z-index: 1;
  }
}

.about-us-content {
  height: 2131rem;
  background: linear-gradient(180deg, #FFFFFF 0%, #F6FAFF 79%, #A3C7F4 93%);
  padding-top: 96rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &.job-content {
    background: #EFEFEF;
    height: auto;
    min-height: 800rem;
    padding: 96rem 0 100rem 0;
    display: flex;
    justify-content: flex-start;
  }

  .introduce {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 1120rem;

    &>div:first-child {
      font-weight: normal;
      font-size: 41rem;
      color: #000000;
    }

    &>div:last-child {
      width: 742rem;
      font-weight: 400;
      font-size: 16rem;
      color: #000000;
      text-align: left;

      &>div {
        margin-bottom: 42rem;
      }
    }
  }

  .company-profile {
    margin-top: 20rem;
    width: 1120rem;
    height: 403rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    font-size: 41rem;
    color: #000000;
    text-align: left;
  }

  .honor {
    margin-top: 142rem;
    width: 1098rem;
  }
}

.ryzz {
  position: relative;
  width: 1098rem;
  display: inline-block;

  .ryzz-list {
    position: relative;
    width: 100%;
    height: 400rem;
    margin-top: 55rem;
    margin-bottom: 200rem;
    z-index: 0;

    .ryzz-viewport {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    :deep(.el-carousel) {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    :deep(.el-carousel__container) {
      height: 400rem;
      overflow: hidden;
    }

    :deep(.el-carousel__item) {
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: transform .5s ease, opacity .35s ease;
    }

    :deep(.el-carousel__item.is-in-stage) {
      opacity: 1;
    }

    :deep(.el-carousel__item.is-active) {
      opacity: 1;
    }

    :deep(.el-carousel__item.is-active .honors-card) {
      box-shadow: 7px 6rem 7rem rgb(152 160 174 / 18%), 0 6rem 14rem rgba(15, 23, 42, 0.08);
    }

    :deep(.el-carousel__item:not(.is-in-stage)) {
      opacity: 0;
      pointer-events: none;

     
    }

    .honors-card {
      position: relative;
      width: 343rem;
      height: 350rem;
      border-radius: 8rem;
      padding-top: 10rem;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #D8D8D8;
      background: transparent;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: box-shadow .35s ease;

      img {
        width: 217rem;
        height: 224rem;
        object-fit: contain;
      }

      .honors-text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 87rem;
        padding: 15rem 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        box-sizing: border-box;
        background-color: #2E76FF;
        font-weight: bold;
        font-size: 16rem;
        color: #FFFFFF;
        line-height: 28rem;
        border-radius: 0 0 8rem 8rem;

        div {
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.xwzx {
  width: 1120rem;
  // background-color: #fff;
  // padding-top: 100rem;
  // padding-bottom: 200rem;

  .more-box {
    font-weight: 400;
    font-size: 18rem;
    color: #D81417;
    font-family: PingFangSC-Medium;
    margin-top: 20rem;

    &>div {
      display: inline-block;
      cursor: pointer;
    }

    span {
      vertical-align: middle;
    }

    img {
      width: 6rem;
      height: 11rem;
      vertical-align: middle;
      margin-left: 6rem;
    }

    padding-bottom: 73rem;
  }

  .xwzx-box {
    width: 1120rem;
    // height: 400rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 36rem;
    background: #FFFFFF;
    border-radius: 12rem;
    padding: 24rem;
    box-sizing: border-box;
    font-size: 0;

    &>div:first-child {
      position: relative;
      width: 640rem;
      height: 360rem;
      background-color: #efefef;
      border-radius: 8rem;
      overflow: hidden;
      cursor: pointer;

      &>div {
        width: 100%;
        height: 75rem;
        line-height: 75rem;
        position: absolute;
        left: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(66, 64, 64, 0) 0%, #1F1E1E 100%);
        border-radius: 0 0 8rem 8rem;
        padding-left: 16rem;
        box-sizing: border-box;
        font-weight: 600;
        font-size: 22rem;
        color: #FFFFFF;
        text-align: left;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    &>div:last-child {
      width: 387rem;
      height: 360rem;
      padding-top: 7rem;
      box-sizing: border-box;

      .news-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        &>div {
          // height: 68rem;
          // margin-top: 26rem;
          text-align: left;
          font-family: PingFangSC-Medium;
          font-weight: bold;
          font-size: 18rem;
          color: #414141;
          cursor: pointer;

          &>div:first-child {
            color: #000000;
          }

          &>div:last-child {
            font-weight: 400;
            font-size: 14rem;
            color: #414141;
            margin-top: 4rem;
          }
        }

        &>div:first-child {
          margin-top: 0;
        }

        .active {
          position: relative;

          &>div {
            color: #2E76FF !important;
          }

          &::before {
            content: '';
            width: 8rem;
            height: 8rem;
            background-color: #2E76FF;
            border-radius: 50%;
            position: absolute;
            left: -20rem;
            top: 13rem;
          }
        }
      }
    }
  }
}

.bg-video {
  position: relative;
  // width: 1920rem;
  height: 620rem;

  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .contact-us {
    width: 1266rem;
    height: 396rem;
    background: rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-clip: padding-box;
    backdrop-filter: blur(6rem);
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    padding: 62rem 72rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #D3D3D3;
    }

    .form-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 59rem;

      &>div {
        position: relative;
        width: 267rem;
        height: 40rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 8rem;
      }
    }

    .submit-btn {
      width: 152rem;
      height: 56rem;
      line-height: 56rem;
      background: #0675FF;
      border-radius: 8rem;
      text-align: center;
      font-weight: 500;
      font-size: 24rem;
      color: #FFFFFF;
      margin-top: 80rem;
      margin-left: 470rem;
      cursor: pointer;
    }
  }

  .contact-service {
    position: relative;
    width: 1266rem;
    height: 396rem;
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12rem;
    border: 1px solid #464646;
    backdrop-filter: blur(12rem);
    padding: 40rem 87rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #fff;
    }

    .title-tips {
      font-weight: 400;
      font-size: 14rem;
      color: #FFFFFF;
      margin-top: 12rem;
      margin-bottom: 50rem;
    }

    .service-list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>div:first-child {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 14rem;
        color: #FFFFFF;

        img {
          width: 123rem;
          height: 123rem;
          margin-bottom: 6rem;
        }
      }

      &>div {
        width: 356rem;
        height: 187rem;
        background: #151515;
        border-radius: 12rem;
        border: 1px solid #4A4A4A;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 40rem 0;
        box-sizing: border-box;

        .fontBold {
          font-weight: bold;
          font-size: 20rem;
          color: #FFFFFF;
        }

        .fontNormal {
          font-weight: 500;
          font-size: 14rem;
          color: #7C7C7C;
        }

      }
    }

    .closed {
      width: 30rem;
      height: 30rem;
      background: url(~@/assets/images/home/close.png);
      background-size: 100% 100%;
      position: absolute;
      right: 30rem;
      top: 25rem;
      cursor: pointer;
    }
  }
}

// 面包屑导航样式
.breadcrumb {
  margin-bottom: 32rem;
  font-size: 16rem;
  color: #666666;
  
  .breadcrumb-link {
    cursor: pointer;
    text-decoration: none;

    font-weight: 500;
font-size: 24rem;
color: #828282;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .breadcrumb-separator {
    margin: 0 8rem;
    color: #999999;
     font-weight: 500;
font-size: 24rem;
color: #828282;
  }
  
  .breadcrumb-current {
    color: #333333;
    font-weight: 500;

    font-weight: 500;
font-size: 24rem;
color: #000000;
  }
}

// 招聘卡片样式
.job-cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 1230rem;
  gap: 16rem;
}

.job-card {
  width: 606rem;
  height: 350rem;
  background: #FFFFFF;
  border-radius: 4rem;
  padding: 32rem;
  box-sizing: border-box;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 10px 0px rgba(6,117,255,0.3);
  }

  .job-title {
    font-size: 24rem;
    font-weight: bold;
    color: #000000;
    margin-bottom: 16rem;
    text-align: start;
  }

  .job-subtitle {
    font-weight: bold;
    margin-bottom: 16rem;
    font-size: 18rem;
    color: rgba(0,0,0,0.7);
    text-align: start;
  }

  .job-responsibilities {
    font-weight: 400;
    font-size: 18rem;
    color: rgba(0,0,0,0.7);

 

    div {
      margin-bottom: 12rem;
      text-align: left;
      
    }
  }
}

// 职位详情页面样式
.job-detail-container {
  width: 100%;
  max-width: 1200rem;
  margin: 0 auto;
}

.job-detail-content {
display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-direction: column;
}

.job-detail-title {
  font-size: 32rem;
  font-weight: bold;
  color: #000000;
  margin-bottom: 32rem;
  text-align: center;
  padding-bottom: 16rem;
  border-bottom: 2px solid #f0f0f0;
}

.job-detail-section {
  margin-bottom: 40rem;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.job-detail-subtitle {
  margin-bottom: 20rem;
  text-align: start;
  position: relative;
  left: -10rem;
  font-weight: bold;
font-size: 24rem;
color: #333333;
}

.job-detail-responsibilities {
  font-weight: 500;

  div {
    margin-bottom: 6rem;
    text-align: left;
    padding-left: 0;
    font-size: 18rem;
    line-height: 30rem;
    color: #333333;
  }
}

.contact-methods {
  display: flex;
  gap: 40rem;
  align-items: flex-start;
  flex-direction: column;
}

.contact-method {
  flex: 1;
}

.contact-label {
  margin-bottom: 12rem;
  text-align: start;

  font-weight: bold;
font-size: 24rem;
color: #333333;
}

.contact-value {
  font-size: 18rem;
  color: rgba(0,0,0,0.7);
}

.contact-qr {
  display: flex;
  justify-content: center;
  align-items: center;
  
  .qr-placeholder {
    width: 120rem;
    height: 120rem;
    background: #f0f0f0;
    border: 2px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 14rem;
    border-radius: 4rem;
  }
}
</style>
